module.exports = __webpack_public_path__ + "img/20220617115843474347.7094c999.jpg";